import { setupListeners } from '@reduxjs/toolkit/query'
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './reducers/auth';
import cartReducer from './reducers/cart';
import apiSlice from './api/apiSlice';
import passwordReducer from './reducers/password'
import checkoutReducer from './reducers/checkout';
import verificationReducer from './reducers/verification';
import { authCacheMiddleware } from './authCacheMiddleware';

const store = configureStore({
    reducer: {
        auth: authReducer,
        cart: cartReducer,
        checkout: checkoutReducer,
        password: passwordReducer,
        verification: verificationReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        authCacheMiddleware,
        apiSlice.middleware,
    )
})


export default store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch


setupListeners(store.dispatch);
